import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

export const Section = styled(Box)(({ theme }) => ({
  margin: `${theme.spacing(3)} 0`,
  width: '100%',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.divider}`,
  width: '100%',
  display: 'block', // Ensure the bottom border extends across the full width
}));

export const InfoGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(2),
  width: '100%',
  marginTop: theme.spacing(2),
}));

export const InfoItem = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
}));

export const Label = styled(Typography)(({ theme }) => ({
  display: 'block',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
}));

export const Value = styled(Typography)(({ theme }) => ({
  display: 'block',
  color: theme.palette.text.primary,
}));

export const StatusBadge = styled(Box)(({ theme, isActive }) => ({
  display: 'inline-block',
  padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
  borderRadius: '16px',
  border: isActive ? `2px solid ${theme.palette.success.dark}` : `2px solid ${theme.palette.error.dark}`,
  fontWeight: 500,
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
}));

export const EmptyValue = styled(Typography)(({ theme }) => ({
  display: 'block',
  color: theme.palette.text.disabled,
  fontStyle: 'italic',
}));
